import React, { useEffect, useState } from 'react';
import { getAllCategory, deleteCategory, sortCategory } from '../services/frontCategoryService';
import { Tree, Card, Button, Modal, message } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined, EditOutlined } from '@ant-design/icons'
import FirstModal from '../components/FrontCategory/FirstModal';
import SecondModal from '../components/FrontCategory/SecondModal';
import ThirdModal from '../components/FrontCategory/ThirdModal';
import _ from 'lodash';
import './front-category.scss';

const { TreeNode } = Tree;
const { confirm } = Modal;
const MODAL = [FirstModal, SecondModal, ThirdModal];
let originTree;

function FrontCategory() {
    const [tree, setTree] = useState();
    const [deep, setDeep] = useState();
    const [current, setCurrent] = useState();
    const [parentId, setParentId] = useState();
    const [dragPId, setDragPId] = useState();
    const CurrentModal = MODAL[deep];
    const visible = deep || deep === 0;

    useEffect(() => {
        getCategory();
    }, []);

    function getCategory() {
        getAllCategory()
            .then(res => {
                const { data } = res || {};
                setTree([_.cloneDeep(data)]);
                originTree = [_.cloneDeep(data)];
            })
    }

    function handleAdd(item) {
        const { id } = item?.category;
        const deep = id?.split('/')?.[1]?.length;
        if(deep != 3) {
            setDeep(deep);
            setParentId(item?.category?.id);
        }
    }

    function handleEdit(item) {
        const { id } = item?.category;
        const deep = id?.split('/')?.[1]?.length;
        if(deep != 0) {
            setDeep(deep - 1);
            setCurrent(item?.category);
        }
    }
    
    function handleModalClose() {
        setDeep(null);
        setCurrent(null);
        setParentId(null);
    }

    function handleDelete(item) {
        const { id, name } = item?.category;
        confirm({
            title: `确认删除类目：${name}？`,
            onOk() {
                return deleteCategory(id)
                    .then(res => {
                        getCategory();
                    })
            }
        })
    }

    function handleSuccess() {
        getCategory();
    }

    function handleDrop(info) {
        const dropKey = info.node.props.eventKey; //拖拽落下的值
        const dragKey = info.dragNode.props.eventKey; //被拖拽的值
        const dropPos = info.node.props.pos.split('-'); //拖拽落下的位置 最外层到最里层
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        const dropKeyPref = dropKey?.slice(0, -1);
        const dragKeyPref = dragKey?.slice(0, -1);
        if((dragKeyPref !== dropKey) && (dragKeyPref !== dropKeyPref)) {
            message.error('非平级不能移动');
            return null;
        }else if(!info.dropToGap && (dragKeyPref === dropKeyPref)) {
            message.error('非平级不能移动');
            return null;
        }  else if(dragPId && dragKeyPref !== dragPId) {
            message.error('一次只能对一个分类下的内容排序');
            return null;
        } 
        
        const data = _.cloneDeep(tree);
        // Find dragObject
        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });
        //dropToGap 若是平级移动,则为true,若是嵌套移动,则为false
        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, item => {
                item.children = item.children || [];
                // where to insert 示例添加到头部，可以是随意位置
                item.children.unshift(dragObj);
            });
        } else if (
            (info.node.children || []).length > 0 && // Has children
            info.node.props.expanded && // Is expanded
            dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, item => {
                item.children = item.children || [];
                // where to insert 示例添加到头部，可以是随意位置
                item.children.unshift(dragObj);
                // in previous version, we use item.children.push(dragObj) to insert the
                // item to the tail of the children
            });
        } else {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar?.splice(i, 0, dragObj);
            } else {
                ar?.splice(i + 1, 0, dragObj);
            }
        }
        if(!dragPId) {
            setDragPId(dragObj?.category?.parentId)
        }
        setTree(data);
    }

    function loop(data, key, callback) {
        data.forEach((item, index, arr) => {
          if (item?.category?.id === key) {
            return callback(item, index, arr);
          }
          if (item?.children) {
            return loop(item.children, key, callback);
          }
        });
    };

    function renderTreeNode(node) {
        return (
            <React.Fragment>
                {node && node.length ?
                    node.map(item => {
                        const isSorting = !!dragPId;
                        const deep = item?.category?.id?.split('/')?.[1]?.length;
                        const editAvailable = !isSorting && deep != 0;
                        const addAvailable = !isSorting && deep != 3;
                        const deleteAvailable = !isSorting && deep != 0 && !(item?.children && item?.children?.length);
                        return (
                            <TreeNode
                                className='front-category-tree-node'
                                key={item?.category?.id}
                                title={
                                    <div className='tree-name-wrap'>
                                        <div className='name'>{item?.category?.name} {item?.category?.id}</div>
                                        {editAvailable && <div className='edit' onClick={() => handleEdit(item)}><EditOutlined /></div>}
                                        {addAvailable && <div className='add' onClick={() => handleAdd(item)}><PlusCircleOutlined /></div>}
                                        {deleteAvailable && <div className='delete' onClick={() => handleDelete(item)}><MinusCircleOutlined /></div>}
                                    </div>}
                            >
                                {item?.children && item?.children.length ? renderTreeNode(item?.children) : null}
                            </TreeNode>
                        )
                    }) : null
                }
            </React.Fragment>
        )
    }

    function handleSortSave() {
        if(dragPId) {
            loop(tree, dragPId, (item, index, arr) => {
                const sortIds = item?.children?.map(item => item?.category?.id);
                sortCategory(sortIds)
                    .then(res => {
                        message.success('保存成功');
                        getCategory();
                        setDragPId(null);
                    })
            })
        }
    }

    function handleSortCancel() {
        setTree(originTree);
        setDragPId(null);
    }

    return (
        <Card className='p-front-category'>
            <Tree
                style={{width: '90%', display: 'inline-block'}}
                autoExpandParent
                draggable
                onDrop={handleDrop}
            >
                {renderTreeNode(tree)}
            </Tree>
            <Button disabled={!dragPId} type='primary' style={{width:'100px', marginRight: '10px'}} onClick={handleSortSave}>保存新排序</Button>
            <Button disabled={!dragPId} style={{width:'100px'}} onClick={handleSortCancel}>取消</Button>
            {(deep || deep === 0) &&
                <CurrentModal
                    current={current}
                    visible={visible}
                    onClose={handleModalClose}
                    parentId={parentId}
                    handleSuccess={handleSuccess}
                />}
        </Card>
    )
}

export default FrontCategory;